export default __webpack_public_path__ + "static/media/card.411e0152.svg";